<template>
    <div class="page-notice">
        <common></common>
    </div>
</template>

<script>

import common from './common.vue';

export default {
    components: {
        common
    },
    data () {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import '@css/var-hzyc.scss';

// 搜索 框
::v-deep .search-head {
    .input-bar {
        .search {
            background: $primaryColor !important;
            &:hover {
                background: $primaryColor8 !important;
            }
        }

        .reset {
            color: $primaryColor;
            border: 1px solid $primaryColor !important;
            &:hover {
                background: $primaryColor1 !important;
            }
        }
    }
}

// 搜索 条件

::v-deep .select-tab {
    .item {
        &:hover,
        &.active {
            background: $primaryColor !important;
            color: #ffffff;
        }
    }
}

::v-deep .list {
    .item {
        .title {
            a {
                &:hover {
                    color: $primaryColor !important;
                }
            }
        }

        .desc {
            .left {
                .tag {
                    color: $primaryColor;
                    background-color: $primaryColor2 !important;
                }
            }
        }
    }
}
</style>